import React, { useState } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import EditIcon from '@atlaskit/icon/core/migration/edit';
import EditorCloseIcon from '@atlaskit/icon/core/migration/close--editor-close';
import { Flex, Grid, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const i18n = defineMessages({
	bannerMessage: {
		id: 'live-pages-features.editor.distinction.banner.message',
		defaultMessage: 'You’re editing this page. Select <b>Update</b> to publish your changes.',
		description: 'Banner message that tells a user they are editing a published page.',
	},
	closeButtonLabel: {
		id: 'live-pages-features.editor.distinction.banner.close.button.label',
		defaultMessage: 'Close editor banner',
		description: 'Label for a button that specifies button is for closing the banner',
	},
});

const bannerStyles = xcss({
	gridTemplateColumns: '1fr auto 1fr',
	backgroundColor: 'color.background.accent.blue.subtlest',
	borderBottom: `1px solid ${token('color.background.accent.blue.subtler')}`,
	color: 'color.text.information',
	padding: 'space.050',
});

const bannerMessageStyles = xcss({
	gridArea: 'message',
});

const closeButtonStyles = xcss({
	gridArea: 'close',
});

export const EditorDistinctionBanner = () => {
	const intl = useIntl();
	const [shouldShowBanner, setShouldShowBanner] = useState<boolean>(true);

	const hideBanner = () => {
		setShouldShowBanner(false);
	};

	return shouldShowBanner ? (
		<Grid
			xcss={bannerStyles}
			alignItems="center"
			templateAreas={['empty message close']}
			testId="editor-distinction-banner"
		>
			<Flex xcss={bannerMessageStyles} alignItems="center" gap="space.075">
				<EditIcon label="" color={token('color.icon.selected')} />
				<FormattedMessage
					{...i18n.bannerMessage}
					values={{
						b: (chunks) => <b>{chunks}</b>,
					}}
				/>
			</Flex>
			<Flex xcss={closeButtonStyles} justifyContent="end">
				<IconButton
					icon={(iconProps) => (
						<EditorCloseIcon {...iconProps} color={token('color.link.pressed')} />
					)}
					label={intl.formatMessage(i18n.closeButtonLabel)}
					appearance="subtle"
					spacing="compact"
					onClick={hideBanner}
					testId="close-button"
				/>
			</Flex>
		</Grid>
	) : null;
};
